





















import { Vue, Component, Prop, Watch, Model } from 'vue-property-decorator';
import debounce from 'lodash/debounce';

interface Element {
    value: any;
    text: string;
}

@Component({})
export default class FilterComponent extends Vue {
    @Prop({ default: () => [] }) fetch!: (value: string) => Promise<Element[]>;
    @Prop() placeholder!: string;
    @Prop() notFoundContent!: string;
    @Prop({ default: false }) disabled!: boolean;
    @Prop({ default: true }) dropDownMatchSelectWidth!: boolean;
    @Model('update:value') readonly value!: string | undefined;

    @Watch('value')
    onValue() {
        this.vModel = this.value;
    }

    @Watch('vModel')
    onVModel() {
        this.$emit('update:value', this.vModel);
    }

    vModel: any = null;
    searching: boolean = false;
    items: Element[] = [];
    debouncedFetchElements = debounce(this.fetchElements, 300);

    onFilterSearch(value: string) {
        this.searching = true;
        this.debouncedFetchElements(value);
    }

    async fetchElements(value: string) {
        this.searching = true;
        this.items = await this.fetch(value);
        this.searching = false;
    }

    onFilter(value: number | undefined) {
        this.$emit('change', value);
    }

    async mounted() {
        this.vModel = this.value;
        await this.fetchElements(this.vModel ? this.vModel : '');
        if (this.vModel && this.items.length == 1) {
            this.$emit('change', this.items[0].value);
        }
    }

    clear() {
        this.vModel = undefined;
        this.$emit('change', undefined);
    }
}
